"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isHeartbeatActive = isHeartbeatActive;
exports.startHeartbeat = startHeartbeat;
exports.stopHeartbeat = stopHeartbeat;
exports.triggerHeartbeat = triggerHeartbeat;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _utils = require("../utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Heartbeat configuration
 */
var HEARTBEAT_INTERVAL = 10 * 60 * 1000; // 10 minutes in milliseconds
var HEARTBEAT_ACTION_NAME = 'studio session heartbeat';
var heartbeatInterval = null;
var initialized = false;

/**
 * Sends a heartbeat action to keep the session alive
 * This includes all important global context attributes for the user/session
 */
function sendHeartbeat() {
  try {
    // Check if analytics is available
    if (typeof window === 'undefined' || !window.DD_RUM) {
      console.warn('System Connect Heartbeat: Analytics not available, skipping heartbeat');
      return;
    }

    // Get current URL path parameters to include in heartbeat
    var urlParams = (0, _utils.getURLPathParams)();

    // Get current timestamp
    var timestamp = new Date().toISOString();

    // Prepare heartbeat data with session context
    var heartbeatData = _objectSpread({
      timestamp: timestamp,
      action: 'keep_session_alive',
      source: 'studio_heartbeat'
    }, urlParams);

    // Send the heartbeat action to analytics
    window.DD_RUM.addAction(HEARTBEAT_ACTION_NAME, heartbeatData);
    console.info('System Connect Heartbeat sent', heartbeatData);
  } catch (error) {
    console.warn('Failed to send System Connect Heartbeat:', error);
  }
}

/**
 * Starts the heartbeat functionality
 * This will send a heartbeat action every 10 minutes to keep the session alive
 *
 * @param {boolean} immediate - Whether to send an immediate heartbeat on start
 */
function startHeartbeat() {
  var immediate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  // Prevent multiple initialization
  if (initialized) {
    console.info('System Connect Heartbeat already initialized');
    return;
  }

  // Check if we're in a browser environment
  if (typeof window === 'undefined') {
    console.warn('System Connect Heartbeat: Not in browser environment');
    return;
  }

  // Check if analytics is available
  if (!window.DD_RUM) {
    console.warn('System Connect Heartbeat: Analytics not available, heartbeat will not start');
    return;
  }
  console.info("Starting System Connect Heartbeat (interval: ".concat(HEARTBEAT_INTERVAL / 60000, " minutes)"));

  // Send immediate heartbeat if requested
  if (immediate) {
    sendHeartbeat();
  }

  // Set up recurring heartbeat
  heartbeatInterval = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL);
  initialized = true;

  // Clean up on page unload
  var cleanup = function cleanup() {
    stopHeartbeat();
  };

  // Safely add event listeners if available
  if (typeof window !== 'undefined' && window.addEventListener) {
    window.addEventListener('beforeunload', cleanup);
  }
}

/**
 * Stops the heartbeat functionality
 */
function stopHeartbeat() {
  if (heartbeatInterval) {
    clearInterval(heartbeatInterval);
    heartbeatInterval = null;
    initialized = false;
    console.info('System Connect Heartbeat stopped');
  }
}

/**
 * Checks if the heartbeat is currently running
 * @returns {boolean} True if heartbeat is active
 */
function isHeartbeatActive() {
  return initialized && heartbeatInterval !== null;
}

/**
 * Manually triggers a heartbeat (useful for testing or immediate session activity)
 */
function triggerHeartbeat() {
  sendHeartbeat();
}